/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    'Wir haben überall gesucht, aber sie existiert nicht. Sie könnte gelöscht worden sein. Es sei denn, in der URL ist ein Tippfehler enthalten 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'Wir konnten nicht finden, wonach Sie suchen',
  'embedded.confluence.already-logged-in-paragraph': 'Bereits eingeloggt? Aktualisieren Sie die Seite.',
  'embedded.confluence.footer.hover.text': 'In Confluence anzeigen',
  'embedded.confluence.footer.prefix': 'Bereitgestellt von',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Bei Confluence einloggen',
  'embedded.confluence.login-page.login-button': 'Bei Confluence einloggen',
  'embedded.confluence.login-page.login-button.aria-label': 'Login-Schaltfläche',
  'embedded.confluence.login-page.login-text': 'Sie müssen eingeloggt sein, damit diese Seite angezeigt wird.',
  'embedded.confluence.login-page.refresh-page-banner':
    'Nach dem Einloggen sollte diese Seite automatisch aktualisiert werden. Wenn dies nicht der Fall ist, können Sie zum Aktualisieren hier klicken.',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Seite aktualisieren',
  'embedded.confluence.need-to-log-in-paragraph': 'Sie müssen eingeloggt sein, damit diese Seite angezeigt wird.',
  'embedded.confluence.still-having-trouble-paragraph':
    'Besteht das Problem weiterhin? Vergewissern Sie sich, dass Cookies von Drittanbietern aktiviert sind, oder {link}',
  'embedded.confluence.troubleshooting-link-text': 'lesen Sie den Leitfaden zur Fehlerbehebung.',
  'embedded.confluence.troubleshooting-link.aria-label': 'Link zum Leitfaden zur Fehlerbehebung',
};
